//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {parser} from "@/utils/parser";

export default {
  name: "SectionJournalsCollectionGrid",
  components: {
    EmptyJournalsCollectionGrid: () => import("@/components/common/EmptyJournalsCollectionGrid"),
    Section: () => import("@/components/common/Section"),
    JournalCard: () => import("@/components/common/JournalCard"),
  },
  data() {
    return {
      title: '',
      journals: [],
      pending: true,
    }
  },
  mounted() {
    this.$axios.$get(`/api/journal-collection?${parser({
      params: {
        resolution: 'micro',
        lang: this.$i18n.locale
      }
    })}`)
      .then(response => {
        this.journals = response.data.journals
        this.title = response.data.title
      })
      .catch(() => null)
      .finally(() => setTimeout(() => {
        this.pending = false
      }, 1000))
  }
}
